import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import ConnectIframeLegacyApp from '@atlassian/jira-connect-iframe-legacy/src/view/view.tsx';
import Src from './view.tsx';

export default withInjectedProps(Src, {
	ConnectIframeLegacyApp,
});
